export default __webpack_public_path__ + "static/media/kid09.ab6af0f8.jpg";